// extracted by mini-css-extract-plugin
export default {"btop":"a2c8ba4b2f _8f66a23132 _62bc1d364e","icon":"_2a0d455847 _824230ddde","btoppink":"_3bb6db65e2 _00b0beaa70"};